const PREFERRED_AUDIO_MIME_TYPES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/ogg;codecs=opus",
  "audio/mp4",
];

function baseMimeType(mimeType: string) {
  return mimeType.split(";")[0]?.trim().toLowerCase() ?? "";
}

export function chooseSupportedAudioMimeType() {
  if (typeof MediaRecorder === "undefined" || typeof MediaRecorder.isTypeSupported !== "function") {
    return "";
  }

  return (
    PREFERRED_AUDIO_MIME_TYPES.find((mimeType) => MediaRecorder.isTypeSupported(mimeType)) ?? ""
  );
}

export function audioFilenameForMimeType(mimeType: string) {
  switch (baseMimeType(mimeType)) {
    case "audio/ogg":
      return "recording.ogg";
    case "audio/mp4":
    case "audio/m4a":
    case "audio/x-m4a":
      return "recording.m4a";
    case "audio/wav":
    case "audio/x-wav":
      return "recording.wav";
    default:
      return "recording.webm";
  }
}
